// import React, { Component } from 'react'
// import "./Login.scss";

// const Webpage = () => {
//     return (
//       <div className='container' >
     
//       </div>
//     );
//   };
// export default Webpage;



import React from 'react';
// import './AddEdit'

function Webpage() {
  return (
    <div>
      {/* <iframe
        src="https://www.figma.com/file/UhO3fNNTnN9vDPdhxOGFVs/PRP-UI?type=design&node-id=2825-4847&mode=design&t=xjjUb2DubJzDJppi-0"
        title="Google"
        style={{ width: '600PX', height: '500px', border: 'none' }}
      /> */}
      <iframe width="2000" height="940" src="https://www.youtube.com/embed/cF2lQ_gZeA8?si=aG9DOrkTFcywghrz" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  );
}

export default Webpage;